export function useCustomQuery() {
    const route = useRoute()
    const { withOnSaleFilter } = useOnSaleFilter()
    const { withIsNewFilter } = useIsNewFilter()

    function buildQuery() {
        return withIsNewFilter(withOnSaleFilter({ ...route.query }))
    }

    return { buildQuery }
}